import { firstCharUppercase, formatDate, formatPrice, upper, currentQuarter, prevQuarter } from "./filtersPlugin";

// Vue 3 Plugin shaklida eksport qilish
export default {
  install(app) {
    app.config.globalProperties.$filters = {
      formatDate,
      firstCharUppercase,
      formatPrice,
      upper,
      currentQuarter,
      prevQuarter,
    };
  },
};

// 🔥 `useFilters()` hookni qo‘shish
export function useFilters() {
  return {
    formatDate,
    firstCharUppercase,
    formatPrice,
    upper,
    currentQuarter,
    prevQuarter,
  };
}
